import { sortConstructionData } from "@sdge-store/construction/construction.async";
import { selectConstruction } from "@sdge-store/construction/construction.selector";
import { handleSort } from "@sdge-store/construction/construction.slice";
import React, { FC, useEffect, useRef } from "react";
import { useAppSelector } from "../../app/hooks";
import { SelectSort, SortOptionsItem } from "./components";
import { Styled } from "./SortOptionsMenu.styled";

const ConstructionSortOptionsMenu: FC = () => {
  const { sort, columnDefs, filteringRules, searchInputValue } =
    useAppSelector(selectConstruction);
  const listEnd = useRef<any>();
  const scrollToBottom = () => {
    listEnd.current.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [sort.length]);
  const unsortedCols = (columnDefs as any[])
    .filter(({ headerName }) => headerName)
    .filter(({ sorting }) => sorting)
    .filter((o1) => !sort.some((o2: any) => o1.sortField === o2.property));
  const sortingCols = unsortedCols
    .map((item, index) => {
      return { id: index, value: item.sortField, label: item.headerName };
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Styled.SortOptionsWrapper>
      <Styled.SortOptionsList>
        {(sort as any[]).map((item, index) => (
          <SortOptionsItem
            key={item.property}
            field={item.property}
            order={item.direction}
            index={index}
            columnDefs={columnDefs}
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortConstructionData}
          />
        ))}
        <Styled.ListBottom ref={listEnd}></Styled.ListBottom>
      </Styled.SortOptionsList>
      <Styled.SelectSortWrapper>
        {sortingCols.length > 0 && (
          <SelectSort
            placeHolder="Add field to sort by"
            optionsData={sortingCols}
            order="ASC"
            sort={sort}
            filteringRules={filteringRules}
            searchInputValue={searchInputValue}
            handleSort={handleSort}
            sortData={sortConstructionData}
          />
        )}
      </Styled.SelectSortWrapper>
    </Styled.SortOptionsWrapper>
  );
};

export default ConstructionSortOptionsMenu;
